import { Component, Prop, Vue } from 'vue-property-decorator'
import Loader from '@/components/Loader/index.vue'
import {
	faChevronLeft,
	faPeopleRoof,
	faHandHoldingDollar,
	faPersonCane,
	faCity,
	faChessKnight,
	faMoneyBillTransfer,
	faFeatherPointed,
} from '@fortawesome/free-solid-svg-icons'
import { library } from '@fortawesome/fontawesome-svg-core'

library.add(
	faChevronLeft,
	faPeopleRoof,
	faHandHoldingDollar,
	faPersonCane,
	faCity,
	faChessKnight,
	faMoneyBillTransfer,
	faFeatherPointed,
)

@Component({
	components: {
		Loader,
	},
})
export default class CalcSelectionModal extends Vue {
	@Prop({ required: true }) calcs!: Array<any>
	selectedGroup = -1
	groups = [
		{
			id: 0,
			name: 'PIS / Cofins',
			icon: faPeopleRoof,
		},
		{
			id: 1,
			name: 'IRPJ / CSLL',
			icon: faHandHoldingDollar,
		},
		{
			id: 2,
			name: 'Previdenciário',
			icon: faPersonCane,
		},
		{
			id: 3,
			name: 'Municipais',
			icon: faCity,
		},
		{
			id: 4,
			name: 'Estaduais',
			icon: faChessKnight,
		},
		{
			id: 5,
			name: 'Transações Administrativas',
			icon: faMoneyBillTransfer,
		},
		{
			id: 6,
			name: 'Outras',
			icon: faFeatherPointed,
		},
	]

	calcsInGroup(groupId) {
		return this.calcs.filter((calc) => groupId === calc.groupId)
	}

	selectGroup(groupId) {
		this.selectedGroup = groupId
	}

	removeSelection() {
		this.selectedGroup = -1
	}

	pushCalc(calc) {
		this.$emit('calc-selected', calc)
	}

	hidden(event) {
		this.$emit('hidden', event)
		this.removeSelection()
	}
}
